import React from "react";
import { useHistory } from "react-router-dom";
import SEO from "../../components/SEO/SEO";
import { FinalCtaCard } from "../../components/landing/PartnerAndCta";
import {
  ComingSoonBand,
  LaunchHero,
  PillarPills,
  PlatformCard,
  PlatformCards,
} from "../../components/landing/LaunchSections";
import { EatHowItWorks, EatOrdering } from "./components/EatOrdering";
import { EatCartAndFavourites, EatCustomisation, EatTracking } from "./components/EatFeatures";
import { EatEverywhere, EatPartner, EatPayment } from "./components/EatClosingSections";
import "./index.css";

const EAT_LAUNCH = "Launching 2027";

const ECOSYSTEM: PlatformCard[] = [
  { label: "WORK", color: "#017bef", title: "Coworking Space", description: "Get things done." },
  { label: "EAT", color: "#0a0a0a", title: "Lunch Order", description: "Order a meal.", highlight: true },
  { label: "STAY", color: "#0062c0", title: "Accommodation", description: "Rest and recharge." },
  { label: "PLAY", color: "#6366f1", title: "Experience", description: "Make the most of it." },
];

const PILLAR_PILLS = [
  { label: "WORK", color: "#017bef" },
  { label: "STAY", color: "#0062c0" },
  { label: "PLAY", color: "#6366f1" },
  { label: "MOVE", color: "#012d6e" },
  { label: "EAT", color: "#0a0a0a" },
];

export default function EatLandingScreen() {
  const history = useHistory();
  const getStarted = { label: "Get Started", onClick: () => history.push("/package-signup") };
  const listRestaurant = { label: "List Your Restaurant", onClick: () => history.push("/partner-signup") };

  return (
    <div className="eat-landing-container min-h-screen flex flex-col">
      <SEO
        title="Order Food, Wherever Your Day Takes You - SPACIA EAT"
        description="Order food from your favourite restaurants, delivered, packed for pickup, or sent straight to your destination of choice — all through the SPACIA app."
      />

      <LaunchHero
        image="/figma-assets/eat/hero.jpg"
        imageAlt="Courier holding a takeaway box"
        pills={
          <>
            <span className="rounded-full bg-[#017bef] px-[16px] py-1.5 text-[12px] font-bold uppercase leading-4 tracking-[1.2px] text-white">
              SPACIA EAT
            </span>
            <span className="rounded-full border-[1px] border-solid border-white/25 px-[16px] py-1.5 text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white/70">
              Coming Soon
            </span>
            <span className="rounded-full bg-white/10 px-[16px] py-1.5 text-[12px] font-semibold leading-4 text-white/60">
              {EAT_LAUNCH}
            </span>
          </>
        }
        titleLines={["Order Food,", "Wherever Your", "Day Takes You"]}
        lead="Order food from your favourite restaurants, delivered, packed for pickup, or sent straight to your destination of choice — all through the SPACIA app."
        body="Eat brings restaurant ordering and delivery onto the SPACIA platform, so ordering a meal feels as effortless as booking a desk, a stay or a spa appointment."
        leadClassName="text-white/70"
        bodyClassName="text-white/50"
        sideShade={0.6}
        primaryCta={getStarted}
        secondaryCta={listRestaurant}
      />
      <EatOrdering />
      <EatHowItWorks />
      <EatCustomisation />
      <EatCartAndFavourites />
      <EatTracking />
      <EatPayment />
      <EatEverywhere />
      <PlatformCards
        eyebrow="The Ecosystem"
        title="Work. Stay. Play. Eat."
        cards={ECOSYSTEM}
        footnote="Food ordering becomes another layer of your SPACIA day — order a meal without ever leaving the app."
      />
      <EatPartner />
      <ComingSoonBand
        title="Eat Is Coming to SPACIA"
        description="Order food from your favourite restaurants, delivered, packed for pickup, or sent straight to your destination of choice — all through the SPACIA app."
        launch={EAT_LAUNCH}
        primaryCta={getStarted}
        secondaryCta={listRestaurant}
      />
      <FinalCtaCard
        eyebrow="One Platform"
        title="One Platform for the Way You Work, Stay, Play and Eat"
        description="SPACIA brings flexible workspaces, quality accommodation and curated lifestyle experiences together so you can spend less time searching and more time doing what matters."
        primaryCta={getStarted}
        secondaryCta={{
          label: "Speak to Our Team",
          onClick: () => {
            window.location.href = "mailto:sales@spacia.africa";
          },
        }}
      >
        <PillarPills pills={PILLAR_PILLS} />
      </FinalCtaCard>
    </div>
  );
}
